// extracted by mini-css-extract-plugin
export default {"highlight":"hb9sXl0kkVx3YTONDnIfMg=="};